<template>
  <v-container>
    <v-row v-if="value.items && value.items.length" align="center">
      <v-col cols="12" xl="7">
        <v-row>
          <v-col v-for="item in value.items" :key="item.id" cols="12" md="4">
            <v-card
              :href="item.href"
              class="fill-height d-flex flex-column pa-4"
              rounded="0"
            >
              <v-card-item class="text-center">
                <v-avatar v-if="item.image" rounded="0" size="150">
                  <v-img
                    :src="imgSrc(item.image)"
                    alt="Photo for the service category"
                  />
                </v-avatar>

                <v-avatar
                  v-else-if="typeof item.icon === 'string'"
                  size="90"
                  style="border-width: 2px"
                  rounded="0"
                  variant="outlined"
                >
                  <v-icon :icon="`hdl:${item.icon}`" size="44" />
                </v-avatar>
              </v-card-item>

              <v-card-title v-if="item.title" class="text-h6">
                <StyledText :value="item.title" />
                <v-icon :icon="mdiArrowRight" color="light-blue-darken-2" />
              </v-card-title>

              <v-card-text
                v-if="item.paragraph"
                class="text-body-1"
                style="line-height: 150%"
              >
                <StyledText :value="item.paragraph" />
              </v-card-text>

              <v-card-actions class="mt-auto">
                <v-btn variant="text">Visit Page</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col
        v-if="value.title || value.paragraph"
        class="mt-8 mt-xl-0"
        cols="12"
        xl="4"
        offset-xl="1"
      >
        <TitleParagraphCard :value="value" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { createImgSrc } from '#root/lib/img'
import { mdiArrowRight } from '@mdi/js'

defineProps({
  value: {
    required: true,
    type: Object
  }
})

const imgSrc = createImgSrc()
</script>
